import CurrencyDisplay from './CurrencyDisplay';

export default CurrencyDisplay;

